import { authWebUsOverlay } from "@ferrivia/auth-web";
import { labUiUsOverlay } from "@ferrivia/lab-ui";
import { questionnaireUiUsOverlay } from "@ferrivia/questionnaire-ui";
import { mergeResources, type Resource } from "@ferrivia/i18n";
import fi from "./locales/fi.json";
import en from "./locales/en.json";
import enUs from "./locales/en.us.json";

export const clientResources: Resource = {
  fi: { client: fi },
  en: { client: en },
};

export const usOverlayResources: Resource = mergeResources(authWebUsOverlay, labUiUsOverlay, questionnaireUiUsOverlay, {
  en: { client: enUs },
});
